import { GridColDef, GridRowId } from '@mui/x-data-grid-pro';
import { FastField, FormikProps } from 'formik';
import { useMemo } from 'react';

import { TStatesAndZips } from '@modules/admin/Tools/LenderUtility/interfaces';
import { PageTitle } from '@modules/admin/Tools/LenderUtility/shared/PageTitle';
import { dataGridCol } from '@shared/components/grid/common';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { statesList } from '@shared/constants/statesList';
import { TextInputField } from '@shared/fields/TextInputField';
import { LocalTabContent } from '@styles/CommonStyles';
import { ExcludedStatesColumn, IncludedItems, RolesContainer } from '@styles/StyledDiv';

const excludedStatesColumns: GridColDef[] = [
  dataGridCol('value', {
    headerName: 'State Code',
    width: 140,
    resizable: false,
  }),
];

interface IIncsAndExcsFormProps extends Partial<FormikProps<TStatesAndZips>> {
  lenderId: string;
}

export const IncsAndExcsForm = ({ setFieldValue, values, lenderId }: IIncsAndExcsFormProps) => {
  const setExcluded = (states: GridRowId[]) => {
    setFieldValue?.('excludedStates', states);
  };

  return useMemo(
    () => (
      <LocalTabContent>
        <RolesContainer>
          <ExcludedStatesColumn>
            <PageTitle sx={{ mb: 2 }}>Excluded States</PageTitle>

            <PhoenixGrid
              checkboxSelection
              name='Excluded States'
              pageSize={statesList.length}
              selectionModel={values?.excludedStates}
              columns={excludedStatesColumns}
              loading={!values?.excludedStates}
              rows={statesList}
              gridId={`Excluded States-${lenderId}`}
              getRowId={(row) => row.value}
              sx={{ mb: 5, height: '73vh' }}
              onSelectionModelChange={setExcluded}
            />
          </ExcludedStatesColumn>

          <IncludedItems>
            <PageTitle sx={{ mb: 2 }}>Included Zip Codes</PageTitle>

            <FastField multiline fullWidth name="includedZipCodes" component={TextInputField} sx={{ mb: 4 }} />

            <PageTitle sx={{ mb: 2 }}>Included Contact IDs</PageTitle>

            <FastField multiline fullWidth name="includedContactIds" component={TextInputField} sx={{ mb: 4 }} />
          </IncludedItems>
        </RolesContainer>
      </LocalTabContent>
    ),
    [values?.excludedStates],
  );
};
